import { useEffect, useState } from "react";
import { useAuth } from "../components/auth/AuthContext";
import api from "../axiosConfig";

export default function useDocumentClosing() {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(user?.use_doc_closing !== false);
  useEffect(() => {
    let active = true;
    let sequence = 0;
    const refresh = async () => {
      const current = ++sequence;
      try {
        const { data } = await api.get("/superadmin/document-settings");
        if (active && current === sequence) setEnabled(data.use_doc_closing !== false);
      } catch {
        if (active && current === sequence) setEnabled(user?.use_doc_closing !== false);
      }
    };
    refresh();
    window.addEventListener("document-settings-changed", refresh);
    window.addEventListener("focus", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      active = false;
      window.removeEventListener("document-settings-changed", refresh);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, [user]);
  return enabled;
}
